import {put, takeLatest, call} from 'redux-saga/effects';
import * as productService from "../../../../services/productService";
import {
    REORDER_PRODUCTS,
    REORDER_PRODUCTS_SUCCESS,
    REORDER_PRODUCTS_ERROR,
}
    from "../../../actions/menu/products";

function* reOrderProductsSaga(action) {
    try {
        yield put({
            type: REORDER_PRODUCTS_SUCCESS,
            payload: action.payload.payload
        });
        yield call(productService.ReOrderProducts,action.payload)
   


    } catch (error) {
        yield put({
            type: REORDER_PRODUCTS_ERROR,error: error.data
        });
    }
}


export function* reOrderProductsSagaWatcher() {
    yield takeLatest(REORDER_PRODUCTS, reOrderProductsSaga);
}